const escapeRegExp = (string) => {
    if (string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    return null;
};

export function getHighlightTextParts({ text = "", search = null }) {
    if (!search) {
        return [];
    }

    const escapedSearchTerm = escapeRegExp(search);
    const parts = text?.split(new RegExp(`(${escapedSearchTerm})`, "gi"));

    return { escapedSearchTerm, parts: parts?.filter((part) => part) };
}
